import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Col, Row, CardHeader } from "reactstrap"
import { buildStyles, CircularProgressbar } from "react-circular-progressbar"
import { withTranslation } from "react-i18next"
import moment from "moment"
import { Avatar } from "antd"
import "./custom-styles.scss"

import pindoraImage from "../../assets/images/devices/pindora.jpeg"
import videoImage from "../../assets/images/devices/video-tablet.jpg"
import trackerImage from "../../assets/images/devices/minifinder-pico.png"
import carephoneImage from "../../assets/images/devices/carephone.png"

const StatusCardHeader = props => {
  const [statusText, setStatusText] = useState("Unknown")
  const [imageSrc, setImageSrc] = useState(null)
  const [statusClass, setStatusClass] = useState("status-green")

  useEffect(() => {
    // Smartlock
    if (props.service == "smartlock") {
      setImageSrc(pindoraImage)
      switch (props.status) {
        case "online":
          setStatusText("Online")
          setStatusClass("status-green")
          break
        case "offline":
          setStatusText("Offline")
          setStatusClass("status-red")
          break
        case "charging":
          setStatusText("Charging")
          setStatusClass("status-green")
          break
        default:
          setStatusText("Unknown device status")
          setStatusClass("status-yellow")
          break
      }
    }
    // Video
    else if (props.service == "video") {
      setImageSrc(videoImage)
      let batteryStatusText = props.batteryState
        ? ` | ${props.batteryState}`
        : ""
      switch (props.status) {
        case "charging":
          setStatusText(`${props.t("Charging")}${batteryStatusText}`)
          setStatusClass("status-green")
          break
        case "discharging":
          setStatusText(`${props.t("Discharging")}${batteryStatusText}`)
          setStatusClass("status-yellow")
          break
        case "shutdown":
          setStatusText(`${props.t("Shutdown")}${batteryStatusText}`)
          setStatusClass("status-red")
          break
        default:
          setStatusText(
            `${props.t("Unknown device status")}${batteryStatusText}`
          )
          setStatusClass("status-yellow")
          break
      }
    } else if (props.service == "tracker") {
      setImageSrc(trackerImage)
      switch (props.status) {
        case "lowbat":
          setStatusText("Low battery")
          setStatusClass("status-yellow")
          break
        case "off":
          setStatusText("Shutdown")
          setStatusClass("status-red")
          break
        case "charging":
          setStatusText("Charging")
          setStatusClass("status-green")
          break
        case "idle":
          setStatusText("Device on")
          setStatusClass("status-green")
          break
        default:
          setStatusText("Unknown device status")
          setStatusClass("status-yellow")
          break
      }
    } else if (props.service == "carephone") {
      setImageSrc(carephoneImage)
      setStatusText(props.status)
      switch (props.status) {
        case "Online":
          setStatusClass("status-green")
          break
        case "Offline":
          setStatusClass("status-red")
          break
        default:
          setStatusClass("status-yellow")
          break
      }
    }
  }, [props.service, props.status])

  const getFontSize = () => {
    if (window.innerWidth <= 340) return "12px"
    else if (window.innerWidth <= 550) return "16px"
    else return "24px"
  }

  return (
    <>
      <CardHeader 
        style={{
          borderRadius: "40px 0"
        }}
        className={
          statusClass + " py-3"
        }
      >
        <Row>
          <Col>
            <div
              className="d-flex"
              style={{
                backgroundColor: "rgba(255,255,255, 0.15)",
                borderRadius: "100px",
                height: "64px",
              }}
            >
              <Avatar
                className="zoom d-none d-md-block"
                size={64}
                src={imageSrc}
                shape="circle"
                style={{ backgroundColor: "#fff" }}
              />
              <div className="d-flex mx-2 col" style={{ alignItems: "center" }}>
                <h2
                  className="m-0"
                  style={{
                    color: "white",
                    fontSize: getFontSize(),
                  }}
                >
                  {props.status === "charging" && (
                    <i
                      className="mdi mdi-battery-charging"
                      style={{ fontSize: "24px", marginRight: "8px" }}
                    ></i>
                  )}
                  {props.t(statusText)}
                </h2>
              </div>
              {props.status !== "Online" && (
                <div
                  className="d-flex col-auto me-4"
                  style={{ alignItems: "center" }}
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: window.innerWidth <= 550 ? "10px" : "16px",
                      whiteSpace:
                        window.innerWidth <= 550 ? "pre-line" : "nowrap",
                    }}
                  >
                    {window.innerWidth <= 550
                      ? `${moment(props.date).format("DD.MM.YYYY")}\n${moment(
                          props.date
                        ).format("HH:mm:ss")}`
                      : moment(props.date).format("DD.MM.YYYY HH:mm:ss")}
                  </span>
                </div>
              )}
            </div>
          </Col>
          {props.battery != null && (
            <Col className="col-auto">
              <div
                style={{
                  width: window.innerWidth <= 550 ? "48px" : "64px", // 70% of original width
                  height: window.innerWidth <= 550 ? "48px" : "64px", // 70% of original height
                }}
              >
                <CircularProgressbar
                  value={props.battery}
                  text={props.battery + "%"}
                  strokeWidth={12}
                  styles={buildStyles({
                    textSize: "22px",
                    pathColor: "#fff",
                    textColor: "#fff",
                    trailColor: "#d0d0d0",
                  })}
                />
              </div>
            </Col>
          )}
        </Row>
      </CardHeader>
    </>
  )
}

StatusCardHeader.propTypes = {
  t: PropTypes.any,
  service: PropTypes.string,
  status: PropTypes.string,
  date: PropTypes.any,
  battery: PropTypes.number,
  batteryState: PropTypes.any,
}

export default withTranslation()(StatusCardHeader)
